import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import CmsElement from 'Components/Utilities/CmsElement';
import {Loading} from 'Components/Partials';

import {translation} from 'Services/TranslationHelpers';
import {getRecordValue} from 'Services/CmsHelpers';
import {asset} from 'Services/BaseHelpers';

export default class Awards extends CmsElement {
    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'awards';

    /**
     * @var paginate
     * @type {boolean}
     */
    paginate = false;

    /**
     * @var state
     */
    state = {
        working: true,
    };

    /**
     * @method render
     * @return {*}
     */
    render () {
        const {working, records} = this.state;

        return (
            <Authenticated>
                <div className="p-4 text-center">
                    <h1 className="font-aleo text-4xl font-bold text-app-blue mb-6">
                        {translation('cms', 'awards')}
                    </h1>

                    {working && <Loading />}

                    {!working &&
                        <div className="bg-app-blue text-white p-4">
                            {records.data !== null && (!records.data || records.data.length === 0) && (
                                <p className="text-center">
                                    {translation('misc', 'no_items', {
                                        item: translation('cms', 'awards')
                                    })}
                                </p>
                            )}

                            {records.data && 
                                <div className='grid lg:grid-cols-2 mt-2 mb-8 gap-6'>
                                    {records.data.map(this.renderItem)}
                                </div>
                            }
                        </div>
                    }
                </div>
            </Authenticated>
        );
    }

    /**
     * @method renderItem
     * @param {object} item
     * @param {string} key
     * @return {JSX.Element}
     */
    renderItem = (item, key) => {
        let title = getRecordValue(item, 'title');
        let text = getRecordValue(item, 'text');

        return (
            <div
                className="flex flex-row gap-4"
                key={key}
            >
                <img
                    src={asset('images/award.png')}
                    className="w-10 h-10"
                />

                <div className="border-b border-white text-left pb-4 w-full">
                    <p className="font-bold">
                        {title}
                    </p>

                    <p className='text-sm'>
                        {text}
                    </p>
                </div>
            </div>
        );
    };
}
